import styled from "styled-components";
import {getCssSizeValue, getFontSize, getHtmlFromRedactorField, getMapKey} from "@/utils/utils";
import Text from "@/components/common/Text";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled.div`
    border: 1px solid ${({theme}) => theme.colors.richBlack};
    padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(42, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
    //aspect-ratio: 335/215;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		aspect-ratio: 314/327;
	}
    .tile-header {
		font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
	    line-height: 150%;
		font-weight: ${({theme}) => theme.fontWeight.semiBold};
		margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
            line-height: normal;
        }
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            font-weight: 900;
            margin-bottom: ${getCssSizeValue(12)};
            min-height: ${getCssSizeValue(52)};
			font-size: ${getFontSize(22, BREAKPOINTS.DESKTOP)};
			line-height: ${getFontSize(22, BREAKPOINTS.DESKTOP)};
        }
    }
`

const Heading = styled(Text)`
	font-size: ${getFontSize(16, BREAKPOINTS.MOBILE)};
	line-height: 150%;
	font-weight: ${({theme}) => theme.fontWeight.bold};
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
		line-height: ${getFontSize(32.4, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(27, BREAKPOINTS.DESKTOP)};
	}
`

const List = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	}
	
	.content {
		padding-left: ${getCssSizeValue(16)};
	}
`

function getData(src) {
	return {
		header: src?.header || '',
		items: src?.items || [],
	}
}

export default function Tile({tile}) {
	const {header, items} = getData(tile)

	return (
		<Wrapper className='col-desktop-3 col-mobile-8 col-tablet-4'>
			<div className='tile-header typo-strawford typo-strawford-63'>{header}</div>
			<List>
				{items.map((item, i) => {
					return (
						<div key={getMapKey(item, i)}>
							<Heading className='square static typo-strawford typo-strawford-65'>
								{item?.header || ''}
							</Heading>
							<div className='content typo-strawford typo-strawford-46' dangerouslySetInnerHTML={getHtmlFromRedactorField(item?.content || '')}/>
						</div>
					)
				})}
			</List>
		</Wrapper>
	)
}
